import { deviceLogin, getStationInfo } from '@api'
export default {
	state: {
		// 设备信息
		deviceInfo: {},
		// 工位信息
		stationInfo: {},
		// 班组信息
		workGroup: {},
		// 工序组
		processGroup: null,
		// 提示信息
		remind: 'close'
	},
	mutations: {
		setRemind(state, remind) {
			state.remind = remind
		},
	},
	actions: {
		setRemind(remind){
			this.commit('setRemind', remind)
		},
		/** 设备登录 */
		async deviceLogin({ state }) {
			let { data: deviceInfo } = await deviceLogin({
				mac: localStorage.getItem("mac"),
				name: localStorage.getItem("deviceName"),
				version: require('/package.json').version
			})
			state.deviceInfo = deviceInfo
			// 获取工位信息
			return await this.dispatch('getStationInfo')
		},
		/** 获取工位信息 */
		async getStationInfo({ state }) {
			let { data } = await getStationInfo()
			state.stationInfo = data.station
			state.workGroupInfo = data.workGroup
			state.processGroup = data.processGroup
			return true
		}
	},
	getters: {
		getStationInfo(state) {
			return state.stationInfo || {}
		},
		getRemind(state) {
			return state.remind || null
		}
	},
}
